export default __webpack_public_path__ + "static/media/farmer.b8e4dfc5.svg";